import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { graphqlService } from '../services/graphqlService';

const PrescreeningTags = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [selectedTags, setSelectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTags = async () => {
      try {
        const activeTags = await graphqlService.getActiveTags();
        setTags(activeTags || []);
      } catch (error) {
        console.error('Error loading tags:', error);
        setTags([]);
      } finally {
        setLoading(false);
      }
    };

    loadTags();
  }, []);

  const handleBack = () => {
    navigate('/prescreening/category');
  };

  const handleNext = async () => {
    if (selectedTags.length > 0 && user && user.email) {
      try {
        // Get existing prescreening data
        let existingData = {};
        try {
          const prescreening = await graphqlService.getPrescreening(user.email);
          if (prescreening) {
            existingData = prescreening;
          }
        } catch (error) {
          // No existing data
        }

        // Update prescreening data
        await graphqlService.createOrUpdatePrescreening({
          userEmail: user.email,
          ...existingData,
          tags: selectedTags,
          completed: true
        });
        
        // Navigate to dashboard with applyFilters flag to retain selected filters
        navigate('/dashboard?applyFilters=true');
      } catch (error) {
        console.error('Error saving prescreening data:', error);
        alert('Failed to save data. Please try again.');
      }
    }
  };

  const toggleTag = (tagName) => {
    setSelectedTags(prev => 
      prev.includes(tagName) 
        ? prev.filter(t => t !== tagName)
        : [...prev, tagName]
    );
  };

  return (
    <div className="prescreening-container">
      <div className="prescreening-header">
        <button className="back-btn" onClick={handleBack}>
          <ArrowLeft size={20} />
          Back
        </button>
        <h1 className="prescreening-title">Choose Your Topics</h1>
      </div>

      <div className="prescreening-progress">
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: '100%' }}></div>
        </div>
      </div>

      <div className="prescreening-content">
        <h2 className="prescreening-question">Select the topics you are interested in (you can select multiple):</h2>
        
        {loading ? (
          <div className="text-center py-8">
            <p>Loading tags...</p>
          </div>
        ) : tags.length === 0 ? (
          <div className="text-center py-8">
            <p>No tags available. Please contact administrator.</p>
          </div>
        ) : (
          <div className="profession-grid">
            {tags.map((tag) => (
              <button
                key={tag._id || tag.name}
                className={`profession-card ${selectedTags.includes(tag.name) ? 'selected' : ''}`}
                onClick={() => toggleTag(tag.name)}
              >
                {tag.displayName || tag.name}
              </button>
            ))}
          </div>
        )}

        <div className="prescreening-actions">
          <button 
            className="prescreening-next-btn"
            onClick={handleNext}
            disabled={selectedTags.length === 0}
          >
            Continue to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrescreeningTags;

